import React, { useState, useEffect, useReducer } from 'react'

import cogniLogo from '../../images/cogni_logo.png'
import LoginImage from '../../images/login_img.png'
import axios from 'axios'
import { propEq, flip } from 'ramda'
import '../../App.css'
import * as R from 'ramda'

const setDefaultWorkspaceURL = (workspaceId) => {
    return [process.env.REACT_APP_SET_DEFAULT_WORKSPACE, workspaceId].join('/')
}

const WorkspaceItem = ({ workspace, willbeDefault }) => {
    return (
        <a
            href={
                willbeDefault
                    ? setDefaultWorkspaceURL(workspace.id)
                    : workspace.workspaceURL
            }
        >
            <div className="accounts_users">
                <div className="accounts_users_name">
                    <div className="accounts_users_name_img">
                        <div className="accounts_users_name_img_circle">
                            <span className="accounts_users_first_name">
                                {R.toUpper(workspace.name[0])}
                            </span>
                        </div>
                        <h5>{workspace.name}</h5>

                        <div className="arrow_clik_user">
                            <div className="accounts_users_name_img_circle_bg arrow_clik_user_active">
                                <span>
                                    <svg
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 49.636 49.636"
                                        style={{
                                            enableBackground:
                                                'new 0 0 49.636 49.636',
                                        }}
                                        xmlSpace="preserve"
                                    >
                                        <polygon points="23.001,27.245 0,23.39 49.636,0.61 25.636,49.026 " />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    )
}

const initialState = {
    loading: true,
    workspaces: null,
    rememberMyselection: false,
}

const wListReducer = (state, action) => {
    const actionIs = flip(propEq('type'))(action)
    if (actionIs('loaded')) {
        return { ...state, workspaces: action.workspaces, loading: false }
    } else if (actionIs('toggleRememberMyselection')) {
        return { ...state, rememberMyselection: !state.rememberMyselection }
    } else {
        throw new Error('Invalid action')
    }
}

const WorkSpaceListing = () => {
    const [state, dispatch] = useReducer(wListReducer, initialState)

    useEffect(() => {
        if (state.loading) {
            axios.get(process.env.REACT_APP_ACCESSIBLE_WORKSPACES_URL).then(
                (wss) => {
                    dispatch({ type: 'loaded', workspaces: wss.data })
                },
                (err) => {
                    console.log('err ::: ', err)
                }
            )
        }
    })

    return (
        <span className="login">
            <div className="login_bg_height">
                <div className="login_bg_width">
                    <div className="row">
                        <div className="col-md-6 col-lg-6 login_bg_width_left">
                            <img
                                className="centerImage"
                                src={cogniLogo}
                                alt="Assistant"
                                title="Assistant"
                            />
                            <h2>
                                Welcome back to <span>Workativ Assistant</span>
                            </h2>
                            <p>Signin to continue to your account</p>
                            <div className="left_bottom_img">
                                <img
                                    src={LoginImage}
                                    align="middle"
                                    alt="Login_img"
                                    title="Login_img"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 login_bg_width_left_right workspace_width_right">
                            <h3>Workspace</h3>
                            <div className="login_bg_height_width_auth">
                                <div className="login_bg_height_auth">
                                    <div className="login_bg_width_auth">
                                        <div className="accounts_users_auth">
                                            {!state.loading
                                                ? state.workspaces.map(
                                                      (w, i) => (
                                                          <WorkspaceItem
                                                              workspace={w}
                                                              key={i}
                                                              willbeDefault={
                                                                  state.rememberMyselection
                                                              }
                                                          />
                                                      )
                                                  )
                                                : null}
                                        </div>
                                    </div>
                                    <div className="checkbox login_checkbox">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={
                                                    state.rememberMyselection
                                                }
                                                onChange={() =>
                                                    dispatch({
                                                        type:
                                                            'toggleRememberMyselection',
                                                    })
                                                }
                                            />
                                            Remember my Selection
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </span>
    )
}

export default WorkSpaceListing
